'use strict';

import { Entity } from '../Entity';
import { App } from '../App';
import { User } from './User';

export enum PROVIDER_REFERENCE {
  DIALPAD = 'dialpad',
  PHONECOM = 'phonecom',
  RINGCENTRAL = 'ringcentral',
}

export class UserIntegrationProvider extends Entity {
  protected id;
  protected name;
  protected reference;
  protected features;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.reference = data.reference;
    this.features = data.features;
  }

  public getName() {
    return this.name;
  }

  public getReference() {
    return this.reference;
  }

  public getId() {
    return this.id;
  }

  public getFeatures() {
    return this.features;
  }
}
